export default "__VITE_ASSET__1MkzJQ40__"